export default __webpack_public_path__ + "static/media/companylogo.52715c1d.svg";